import { useQuery } from '@tanstack/react-query';
import { llmBenchmarkService } from '@/services/llmBenchmarkService';

export function useBenchmarkRuns() {
  return useQuery({
    queryKey: ['admin', 'llm-benchmarks', 'runs'],
    queryFn: () => llmBenchmarkService.listRuns(),
    staleTime: 30_000,
  });
}

export function useBenchmarkReport(runId: string | null, slug: string | null) {
  return useQuery({
    queryKey: ['admin', 'llm-benchmarks', 'report', runId, slug],
    queryFn: () => {
      if (!runId || !slug) throw new Error('Missing runId or slug');
      return llmBenchmarkService.getReport(runId, slug);
    },
    enabled: !!runId && !!slug,
    staleTime: 5 * 60_000,
  });
}

export function useBenchmarkReportData(
  runId: string | null,
  slug: string | null,
) {
  return useQuery({
    queryKey: ['admin', 'llm-benchmarks', 'data', runId, slug],
    queryFn: () => {
      if (!runId || !slug) throw new Error('Missing runId or slug');
      return llmBenchmarkService.getReportData(runId, slug);
    },
    enabled: !!runId && !!slug,
    staleTime: 5 * 60_000,
    // 404 = older run with no JSON sidecar; don't keep retrying.
    retry: (failureCount, err) => {
      const status = (err as { response?: { status?: number } })?.response?.status;
      if (status === 404) return false;
      return failureCount < 2;
    },
  });
}
